import { Select, SelectProps } from 'antd'
import styles from './Select.module.less'
import { DataTestId } from 'src/constants/ui.constants'

export type SelectCompProps = {
    dropdownRender?: (menu: React.ReactElement) => React.ReactElement
    optionRender?: SelectProps['optionRender']
    height?: string | number
    onChange?: (value: string) => void
    onDropdownVisibleChange?: (visible: boolean) => void
    options?: SelectProps['options']
    placeholder?: string
    style?: React.CSSProperties
    value?: string
    width?: string | number
    allowClear?: boolean
    onClear?: () => void
    handleInputKeyDown?: SelectProps['onInputKeyDown']
    handleKeyDown?: (e: { key: string }) => void
    isOpen?: boolean
    shouldDisableTyping?: boolean
}

const SelectComp: React.FC<SelectCompProps> = props => {
    const customStyle: React.CSSProperties = {
        height: props.height,
        width: props.width,
        ...props.style,
    }

    return (
        <Select
            dropdownRender={props.dropdownRender}
            optionRender={props.optionRender}
            onChange={props.onChange}
            onDropdownVisibleChange={props.onDropdownVisibleChange}
            options={props.options}
            placeholder={props.placeholder}
            style={customStyle}
            value={props.value}
            className={styles.select}
            allowClear={props.allowClear}
            showSearch={props.shouldDisableTyping !== undefined ? !props.shouldDisableTyping : true}
            onClear={props.onClear}
            onKeyDown={props.handleKeyDown}
            onInputKeyDown={props.handleInputKeyDown}
            open={props.isOpen}
            data-testid={DataTestId.Select}
        />
    )
}

export default SelectComp
